export const getTranslations = t => {
  return {
    familyResults: t("kf.viewFamilyResults"),
    viewSterlingResults: t("kf.viewSterlingResults"),
  }
}
